import type { FC, SVGProps } from 'react';

export const ExclamationCircleIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="22"
      fill="none"
      height="23"
      viewBox="0 0 22 23"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3002_1318)">
        <path
          fill="currentColor"
          d="M11 0.5C4.92545 0.5 0 5.42545 0 11.5C0 17.5746 4.92545 22.5 11 22.5C17.0746 22.5 22 17.5746 22 11.5C22 5.42545 17.0746 0.5 11 0.5ZM11 20.6339C5.9567 20.6339 1.86607 16.5433 1.86607 11.5C1.86607 6.4567 5.9567 2.36607 11 2.36607C16.0433 2.36607 20.1339 6.4567 20.1339 11.5C20.1339 16.5433 16.0433 20.6339 11 20.6339Z"
        />
        <path
          fill="currentColor"
          d="M9.82104 15.8214C9.82104 16.134 9.94522 16.4338 10.1662 16.6548C10.3873 16.8758 10.687 17 10.9996 17C11.3122 17 11.612 16.8758 11.833 16.6548C12.054 16.4338 12.1782 16.134 12.1782 15.8214C12.1782 15.5089 12.054 15.2091 11.833 14.9881C11.612 14.767 11.3122 14.6429 10.9996 14.6429C10.687 14.6429 10.3873 14.767 10.1662 14.9881C9.94522 15.2091 9.82104 15.5089 9.82104 15.8214ZM10.4103 13.0714H11.5889C11.6969 13.0714 11.7853 12.983 11.7853 12.875V6.19643C11.7853 6.08839 11.6969 6 11.5889 6H10.4103C10.3023 6 10.2139 6.08839 10.2139 6.19643V12.875C10.2139 12.983 10.3023 13.0714 10.4103 13.0714Z"
        />
      </g>
    </svg>
  );
};
